/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer.jsx';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import BackTextButton from 'components/Buttons/BackTextButton';
import CustomTextButtom from 'components/Buttons/CustomTextButton';
import { simCardInfoHelper } from 'helpers/simCardInfoHelper';
import { FormGeneralHelper } from 'helpers/FormGeneral';
import { history } from 'core/history';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Auth } from '../../modules/auth/Auth';
import { ProductViewDetail } from './component/ProductViewDetail';
import { ProductRemove } from './component/ProductRemove';
import { SimCardOperationHelper } from '../../helpers/SimCardOperationHelper';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import { ProductChangeProfile } from './component/ProductChangeProfile';
import { ProductChangeLanguage } from './component/ProductChangeLanguage';

class SimCardViewCommon extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            info: null,
        };
    }

    synchronizeCallback = (params) => {
        const { dispatch } = this.props;
        simCardInfoHelper.onSuccess(this, 'info', params, (params) => {
            SimCardOperationHelper.synchronizeCallback(params, dispatch);
        });
    };

    goToIccidStorage = () => {
        history.push(FormGeneralHelper.getRouteUrl('/iccid-view' + this.props.item.platformIccidPoolNumber));
    };

    render() {
        const { info } = this.state;
        const { item, callback, itemsLoader, classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <ProductViewDetail product={item} />
                </GridItem>
                <GridItem xs={12} style={{ marginTop: 15 }}>
                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_ICCID_POOL_NUMBER_GET) && item.deleted === false && (
                        <CustomTextButtom callback={this.goToIccidStorage} label="simcard:list.storage" callbackParam={{}} size="sm" />
                    )}
                    {UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_SYNCHRONIZE_POST) && (item.deleted === false || Auth.isExpertMode()) && (
                        <CustomTextButtom
                            callback={this.synchronizeCallback}
                            callbackParam={{ simCardId: item.id, fullSynchronize: false }}
                            label="simcard:list.synchronize_sim_card"
                            size="sm"
                        />
                    )}
                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_OPERATION_ON_SIMCARD_REMOVE_CONTRACT) && item.deleted === false && (
                        <ProductRemove product={item} itemLoader={itemsLoader} classes={classes} />
                    )}
                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_TARIFF) &&
                        item.deleted === false &&
                        item.profileAllowChange === true && <ProductChangeProfile product={item} classes={classes} reload={this.refreshPage} />}
                    {item.deleted === false && <ProductChangeLanguage product={item} classes={classes} reload={this.refreshPage} />}
                    <BackTextButton callback={callback} size="sm" />
                    {info}
                </GridItem>
            </GridContainer>
        );
    }
}

SimCardViewCommon.propTypes = {
    classes: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {};
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(SimCardViewCommon);
export default Enhance;
